export default __webpack_public_path__ + "static/media/user-circle-oc.d496e2ad.svg";